// Admin panel se bet place nahi hoti. Kai game pages `<PlaceBet>` render karte the
// bina import kiye — odds par click karte hi "Element type is invalid" se poora
// page crash (white screen) ho jaata tha. Ye stub un pages ka PlaceBet hai: kuch
// render nahi karta.
export default function NoBet() {
  return null;
}
